module.exports = __webpack_public_path__ + "img/message.2f6a94ec.svg";